import { array } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';

import joinClasses from 'webapp/helpers/join-classes';
import AvatarOrInitialsComponent from 'webapp/components/avatar-or-initials';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';

import type Source from 'webapp/models-custom/source';

interface Args {
	model: Source;
	selectedId: string;
	onSelect: (model: Source) => void;
}

export default class WizardDatasourceComponent extends Component<Args> {
	get isSelected() {
		return this.args.selectedId === this.args.model.id;
	}

	get isDisabled() {
		const statusObject = this.args.model.statusObject;
		return statusObject?.isError || statusObject?.isOnHold || statusObject?.isDatasetError;
	}

	@action
	click() {
		if (this.isDisabled) {
			return;
		}
		this.args.onSelect(this.args.model);
	}
	<template>
		<a
			class={{joinClasses
				(array
					"list-item datasource"
					(if this.isSelected "selected")
					(if this.isDisabled "disabled")
				)
			}}
			{{on "click" this.click}}
		>

			<div class="col img">
				<AvatarOrInitialsComponent
					@name={{@model.subtitle}}
					@avatar={{@model.realAvatar}}
				/>
			</div>

			<div class="col profile">
				<span>
					{{@model.title}}
					{{#if @model.isDataset}}
						<CommonUiIconComponent @name="Table" @size="sm" />
					{{/if}}
				</span>
				{{@model.subtitle}}
			</div>

			<div class="col details">
				{{{@model.createdText}}}
			</div>

			<div class="col status">
				<span class={{@model.statusClass}}>
					<CommonUiIconComponent @name={{@model.statusIconClass}} @size="sm" />
					{{@model.statusTitle}}
				</span>
			</div>

		</a>
	</template>
}
